<template>
  <div class="max-w-3xl mx-auto space-y-6">
    <Paragraph>
      {{ t("privacy.intro_text") }}
    </Paragraph>

    <Section :title="t('privacy.our_promises_title')">
      <ul class="list-disc list-inside space-y-2">
        <ListItem
          v-for="(_, index) in ourPromisesList"
          :key="index"
          :text="t(`privacy.our_promises_list[${index}]`)"
        />
      </ul>
    </Section>

    <Section :title="t('privacy.personal_data_title')">
      <Paragraph>{{ t("privacy.personal_data_intro") }}</Paragraph>
      <ul class="list-disc list-inside space-y-2">
        <ListItem
          v-for="(_, index) in personalDataList"
          :key="index"
          :text="t(`privacy.personal_data_list[${index}]`)"
        />
      </ul>
    </Section>

    <Section :title="t('privacy.other_data_title')">
      <Paragraph>{{ t("privacy.other_data_intro") }}</Paragraph>
      <ul class="list-disc list-inside space-y-2">
        <ListItem
          v-for="(_, index) in otherDataList"
          :key="index"
          :text="t(`privacy.other_data_list[${index}]`)"
        />
      </ul>
    </Section>

    <Section :title="t('privacy.purpose_title')">
      <Paragraph>{{ t("privacy.purpose_text") }}</Paragraph>
      <Paragraph>{{ t("privacy.purpose_consent_text") }}</Paragraph>
    </Section>

    <Section :title="t('privacy.security_title')">
      <Paragraph>{{ t("privacy.security_text") }}</Paragraph>
    </Section>

    <Section :title="t('privacy.third_parties_title')">
      <Paragraph>{{ t("privacy.third_parties_text") }}</Paragraph>
    </Section>

    <Section :title="t('privacy.automated_decisions_title')">
      <Paragraph>{{ t("privacy.automated_decisions_text") }}</Paragraph>
    </Section>

    <Section :title="t('privacy.cookies_title')">
      <Paragraph>{{ t("privacy.cookies_text") }}</Paragraph>
    </Section>

    <Section :title="t('privacy.third_party_websites_title')">
      <Paragraph>{{ t("privacy.third_party_websites_text") }}</Paragraph>
    </Section>

    <Section :title="t('privacy.privacy_rights_title')">
      <Paragraph>{{ t("privacy.privacy_rights_text") }}</Paragraph>
    </Section>

    <Section :title="t('privacy.contact_title')">
      <div class="bg-base-200 p-6 rounded-lg shadow-sm">
        <table class="text-left w-full">
          <tbody class="divide-y divide-gray-200">
            <tr v-for="(value, key) in contactInfo" :key="key">
              <th class="pr-4 text-left capitalize">{{ key }}:</th>
              <td>{{ value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Section>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import Section from "@/components/ui/Section.vue";
import Paragraph from "@/components/ui/Paragraph.vue";
import ListItem from "@/components/ui/ListItem.vue";

const { t, locale, messages } = useI18n();

const ourPromisesList =
  ((messages.value[locale.value] as any)?.privacy
    ?.our_promises_list as string[]) || [];

const personalDataList =
  ((messages.value[locale.value] as any)?.privacy
    ?.personal_data_list as string[]) || [];
const otherDataList =
  ((messages.value[locale.value] as any)?.privacy
    ?.other_data_list as string[]) || [];

const contactInfo = {
  Bedrijfsnaam: t("privacy.contact_info.company"),
  Adres: t("privacy.contact_info.address"),
  "E-mailadres": t("privacy.contact_info.email"),
  LinkedIn: t("privacy.contact_info.linkedin"),
  "KvK-nummer": t("privacy.contact_info.kvk"),
  "Btw-nummer": t("privacy.contact_info.vat"),
};
</script>
